import { Col, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { RootState } from "store/Reducers";
import { useGetAdvertDurationStats } from "../ServerSideStates";
import CustomNoData from "apps/Common/CustomNoData";
import dayjs from "dayjs";
import PageTitle from "apps/Common/PageTitle";

const AdPublicationPeriod = () => {


  const { filter } = useSelector(
    (state: RootState) => state.competitorAnalysisRepor
  );
  const reports = useGetAdvertDurationStats(filter);

  return (
    <>
      <Row  gutter={[20,20]} className="!shadow-lg !rounded-md !p-4 !bg-gray-50 ">
      <Col span={24} className="!flex !justify-center md:!justify-start" >
          <PageTitle  textClassNames="!text-gray-400" title="İlan Yayın Süresi" />
        </Col>
     
 
        {reports?.data?.data?.length > 0 ? (
          <>
            <Col xs={24}>
              <ResponsiveContainer width="100%" height={400}>
                <AreaChart
                  data={reports?.data?.data.map((item: any) => {
                    return {
                      date: dayjs(item.date).format("DD.MM.YYYY"),
                      EmlakOfisim: item.myOfficeAverageDuration,
                      BolgeOrtalamasi: item.regionAverageDuratio,
                    };
                  })}
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 30,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="date"
                    tick={(props) => {
                      const { x, y, payload } = props;
                      return (
                        <g transform={`translate(${x},${y})`}>
                          <text
                            x={0}
                            y={0}
                            dy={10}
                            transform="rotate(-45)"
                            textAnchor="end"
                            fontSize={12}
                            fill="#666"
                          >
                            {payload.value}
                          </text>
                        </g>
                      );
                    }}
                  />
                  <YAxis />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="emlakOfisi"
                    stroke="#007bff"
                    fill="#007bff"
                    fillOpacity={0.2}
                  />
                  <Area
                    type="monotone"
                    dataKey="bolgeOrtalamasi"
                    stroke="#d9534f"
                    fill="#d9534f"
                    fillOpacity={0.2}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Col>
          </>
        ) : (
          <>
            <div className="!h-[400px] !flex justify-center !w-full">
            <CustomNoData />
          </div>
          </>
        )}
      </Row>
    </>
  );
};

export default AdPublicationPeriod;
